import React from "react";
import { Chart } from "primereact/chart";
import ChartDivider from "../../ChartDivider";
import ChartSkeleton from "../../../Skeletons/ChartSkeleton";
import DataAndQuantityType from "./DataAndQuantityType";
import ExperienceTable from "./ExperienceTable";
import { getUsesPerDayChartOptions } from "../../../../utils/chartOptions/dashboard/frequency";
import { getExperienceSChartOptions } from "../../../../utils/chartOptions/dashboard/experiences";
import { toSentenceCase } from "../../../../utils/constants";
import NoChartData from "../../../sharedComponents/NoChartData";

const buttonOptions = [
  {
    name: "Top Box (%)",
    value: "Single",
    subTitle: "% of survey responses saying 'Very Satisfied'",
    headerSubTitle: true,
  },
  {
    name: "Top Two Box (%)",
    value: "Two",
    subTitle:
      "% of survey responses saying 'Very Satisfied' or 'Somewhat Satisfied'",
    headerSubTitle: true,
  },
  {
    name: "Mean Score (Avg)",
    value: "Mean",
    subTitle: "Average response - 5 point scale",
    headerSubTitle: false,
  },
  {
    name: "Full Data",
    value: "Full",
    subTitle: "",
    headerSubTitle: false,
  },
];

const OverallSatisfaction = React.memo(function OverallSatisfaction(props) {
  const {
    activeDataTypeButton,
    setActiveDataTypeButton,
    overAllSatisfactionChartData,
    chartQuestion,
    loading = false,
  } = props;
  // const maxDataValue = Math.max(
  //   ...(Array.isArray(props?.overAllSatisfactionChartData?.datasets) // Ensure datasets is an array
  //     ? props.overAllSatisfactionChartData.datasets.flatMap(
  //         (dataset) => (Array.isArray(dataset?.data) ? dataset.data : []), // Ensure dataset.data is an array
  //       )
  //     : [0]), // Default to [0] if datasets is undefined or not an array
  // );

  // const suggestedMax = Math.ceil(maxDataValue / 10) * 10 + 10; // Rounds up to nearest 10 and adds extra 10%

  // const options = {
  //   barThickness:
  //     props?.overAllSatisfactionChartData?.datasets === 1 ? 300 : undefined,
  //   // indexAxis: "y", // Horizontal bar chart
  //   // maintainAspectRatio: false,
  //   // aspectRatio: 0.7,
  //   plugins: {
  //     legend: {
  //       display: true,
  //       position: "top",
  //       align: "start",
  //       labels: {
  //         padding: 15,
  //         font: { size: 12, weight: "bold" },
  //         color: "#6C757D",
  //       },
  //     },
  //     datalabels: {
  //       color: "#000",
  //       anchor: "end",
  //       align: "right",
  //       font: { weight: "bold", size: 12 },
  //       formatter: (value) => (value !== 0 ? value : ""),
  //     },
  //   },
  //   scales: {
  //     x: {
  //       stacked: false, // Stack the bars horizontally
  //       suggestedMax: suggestedMax,
  //       ticks: {
  //         font: { size: 12, weight: "bold" },
  //       },
  //     },
  //     y: {
  //       beginAtZero: true,
  //       ticks: {
  //         font: { size: 12, weight: "bold" },
  //       },
  //     },
  //   },
  // };

  const options = getExperienceSChartOptions(
    overAllSatisfactionChartData,
    activeDataTypeButton,
  );

  const processTableLabel = () => {
    if (
      overAllSatisfactionChartData?.labels &&
      overAllSatisfactionChartData?.labels?.length
    ) {
      let tableDataVal = overAllSatisfactionChartData;
      let tableDataValLables = [
        "Total uses surveyed",
        ...tableDataVal?.labels,
        "Mean",
      ];
      tableDataVal.labels = tableDataValLables;
      return tableDataVal;
    } else {
      return overAllSatisfactionChartData;
    }
  };

  return (
    <div className="mt-4" style={{ maxWidth: "100%" }}>
      <div className="mb-4">
        <DataAndQuantityType
          buttonOptions={props?.chartQuestion ? buttonOptions : []}
          activeDataTypeButton={activeDataTypeButton}
          setActiveDataTypeButton={setActiveDataTypeButton}
          headerText={`Overall Satisfaction`}
          headerSubTitle={
            buttonOptions.find(
              (option) => option.value === activeDataTypeButton,
            )?.headerSubTitle ? (
              <span>
                Base: XMOT<sup>&reg;</sup> Surveys
              </span>
            ) : (
              ""
            )
          }
          subTitle={
            buttonOptions.find(
              (option) => option.value === activeDataTypeButton,
            )?.subTitle
          }
        />

        {props?.chartQuestion ? (
          <>
            <div className="col-12 pb-4">
              {activeDataTypeButton === "Full" ? (
                <ExperienceTable
                  tableData={processTableLabel()}
                  question={chartQuestion}
                  loading={loading}
                />
              ) : (
                <>
                  <Chart
                    redraw={(
                      props?.isFilterHide || props?.showSidebar
                    ).toString()}
                    type="bar"
                    data={props?.overAllSatisfactionChartData}
                    options={options}
                  />
                </>
              )}
            </div>
            <p
              style={{ width: "90%" }}
              className="p-2 fs-12 text-start rounded-2 fw-bold border text-secondary"
            >
              {toSentenceCase(props?.chartQuestion)}
            </p>
          </>
        ) : loading ? (
          <ChartSkeleton />
        ) : (
          <NoChartData
            msg={"No Data available to display in the chart at the moment."}
          />
        )}
        <ChartDivider />
      </div>
    </div>
  );
});

export default OverallSatisfaction;
